<template>
  <div class="time-wrap">
    <span class="letter" v-if="day > 0"
      >{{ day }} {{ day > 0 ? "天" : "" }}</span
    >
    <span class="letter" v-if="hour > 0">{{ hour }}时</span>
    <span class="letter">{{ min }}分</span>
    <span class="letter">{{ sec }}秒</span>
  </div>
</template>
<script>
export default {
  name: "count-down",
  data() {
    return {
      hour: "00",
      min: "00",
      sec: "00",
      day: 0,
      endText: "已过期",
      showEnd: true
    };
  },
  props: {
    endTime: {
      type: Date,
      default: ""
    }
  },
  mounted() {
    if (this.endTime) {
      this.countdown(this.endTime);
    }
  },
  methods: {
    countdown(timestamp) {
      let self = this;
      let timer = setInterval(function() {
        let nowTime = new Date();
        let endTime = new Date(timestamp);
        let t = endTime.getTime() - nowTime.getTime();
        if (t > 0) {
          self.showEnd = false;
          let day = Math.floor(t / 86400000);
          let hour = Math.floor((t / 3600000) % 24);
          let min = Math.floor((t / 60000) % 60);
          let sec = Math.floor((t / 1000) % 60);
          hour = hour < 10 ? "0" + hour : hour;
          min = min < 10 ? "0" + min : min;
          sec = sec < 10 ? "0" + sec : sec;
          if (day > 0) {
            self.day = day;
            self.hour = hour;
            self.min = min;
            self.sec = sec;
          }
          if (day <= 0 && hour > 0) {
            self.day = 0;
            self.hour = hour;
            self.min = min;
            self.sec = sec;
          }
          if (day <= 0 && hour <= 0) {
            self.hour = "00";
            self.min = min;
            self.sec = sec;
          }
        } else {
          self.showEnd = true;
          clearInterval(timer);
        }
      }, 1000);
    }
  }
};
</script>
<style scoped>
.time-wrap {
  display: inline;
  font-size: 0;
}
.letter {
  font-size: 24px;
  font-weight: 500;
  color: #ff0000;
  /* margin-left: 1px; */
}
</style>



// WEBPACK FOOTER //
// src/components/pay-countdown/index.vue